import React from 'react';
import { useGoodsDetail } from '../../../queries/useGoodsDetail';
import { isNil } from 'shared/src/utils';
import { Colors, Flex, IconTimer, Typography } from '@banhala/ui-kit';
import { TimerText } from './TimerText';

export const TimeSaleBanner: React.FC = () => {
  const { data: goodsDetail } = useGoodsDetail();

  if (isNil(goodsDetail)) return null;

  if (isNil(goodsDetail.time_sale_banner)) return null;

  return (
    <Flex.Row
      alignItems={'center'}
      height={36}
      justifyContent={'center'}
      backgroundColor={'pink5'}
      gap={4}
    >
      <IconTimer size={16} fill={Colors.content_pink_primary} />
      <Typography type={'body3'}>
        {goodsDetail.time_sale_banner.title}
      </Typography>
      <TimerText expiredAt={goodsDetail.time_sale_banner.finished_at} />
    </Flex.Row>
  );
};
